import { useMutation, } from "@tanstack/react-query";
export const createAuthQueries = (requests, queryClient) => ({
    useChangePassword: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.changePassword,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["current-user"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useResetPassword: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.resetPassword,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["current-user"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useLogin: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.login,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["current-user"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
    useLogout: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.logoutUser,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["current-user"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map